<div class="setlist-planning-container" [ngClass]="{'playlist-col': playlistMode}">
  <!--  <nav class="timeslot-actions"> -->
  <!--    <button class="week-btn rounded-button font-size-14" (click)="scheduleModeChanged.emit()" [ngClass]="{'selected': activeDay != '24'}"> -->
  <!--      {{'planning.week' | translate}} -->
  <!--    </button> -->
  <!--    <button class="day-btn rounded-button font-size-14" (click)="scheduleModeChanged.emit('24')" [ngClass]="{'selected': activeDay == '24'}">-->
  <!--      {{'planning.24' | translate}}-->
  <!--    </button>-->
  <!--  </nav> -->
  <!--h2>Planning</h2-->
  <section [ngClass]="{'modifier-page-max-height': fromModifierPage}" class="timeslot-list">
    <mwo-setlist-planning-item class="timeslot-item" *ngFor="let timeSlot of setlist;  let i = index"
                               [animateEqualizer]="isPlayingFromSchedule" [color]="getVisibleColor(timeSlot)"
                               [fromModifierPage]=fromModifierPage [id]="'item-' + i"
                               [timeSlot]="timeSlot"></mwo-setlist-planning-item>
  </section>
</div>
